// @flow

type HasMinLengthValues = (allData: Array<string>, selectedData: Array<string>) => boolean;

export const hasMinLengthValues: HasMinLengthValues = (allData, selectedData) => (
    allData.reduce((prev, curr) => {
        if (prev === false) {
            return prev;
        }
        return selectedData.some(el => el === curr);
    }, true)
);
